/**
 * Member URL Redirect Logic
 *
 * Pure function that determines if a member user should be redirected from
 * OCHIN-facing release note URLs to member-facing test plan URLs.
 *
 * Member users should not see OCHIN release note views directly. They should
 * be redirected to their service area's test plan view instead.
 */

/**
 * Determines if a member user needs to be redirected to test plan view
 *
 * @param {Object} userContext - User context information
 * @param {boolean} userContext.isOchinUser - Whether user is an OCHIN staff member
 * @param {string} userContext.serviceArea - User's service area ID
 * @param {Object} currentRoute - Current route information
 * @param {string} currentRoute.name - Current route name
 * @param {Object} currentRoute.params - Current route params (releaseNoteId, etc)
 * @returns {Object|null} Redirect route object, or null if no redirect needed
 */
export function getMemberRedirect(userContext, currentRoute) {
  const { isOchinUser, serviceArea } = userContext;
  const { name: currentRouteName, params } = currentRoute;

  // Only redirect member users (non-OCHIN)
  if (isOchinUser) {
    return null;
  }

  // Redirect release note view to test plan view for members
  if (currentRouteName === "releaseNoteView") {
    return {
      name: "testPlanView",
      params: { ...params, serviceAreaId: serviceArea },
    };
  }

  // No redirect needed
  return null;
}
